import React from "react";
import ImageWrapper from "./ImageWrapper";
import Link from "next/link";
import { useRouter } from "next/router";

function CmsCollection({ component, page_id = "" }) {
  const router = useRouter();

  const mesi = [
    "GENNAIO",
    "FEBBRAIO",
    "MARZO",
    "APRILE",
    "MAGGIO",
    "GIUGNO",
    "LUGLIO",
    "AGOSTO",
    "SETTEMBRE",
    "OTTOBRE",
    "NOVEMBRE",
    "DICEMBRE",
  ];

  let baseUrl =
    router.asPath.split("/page").join("");
  // console.log(router.asPath);
  return (
    <div
      className={`griglia grid-cols-${component.options.itemsPerRow}`}
      id={`${component.id ?? ""}`}
    >
      {component.options.items.map(function (card, i) {
        const project_url = `${baseUrl + "/" + card.slug + "/" + component.options.slug}/${card.id}`;
        return (
          <div key={`card_${i}`}>
            <div className="card">
              <div className="cardContent">
                <div className="caption" data-aos="fade-right">
                  <div>
                    <Link href={project_url}>
                      <a target={"_self"} className="box">
                        <span>{i + 1 <= 9 ? "0" + (i + 1) : i + 1}</span>
                        {card.title}
                      </a>
                    </Link>
                  </div>
                  <div>
                    <div className="dt">
                      <p>
                        {mesi[new Date(card.date).getMonth()]}{" "}
                        {new Date(card.date).getFullYear()}
                      </p>
                    </div>
                    <Link href={project_url}>
                      <a target={"_self"} className="externalBtn">
                        <span>VEDI DETTAGLIO</span>
                        <svg viewBox="0 0 24 24">
                          <path d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z" />
                        </svg>
                      </a>
                    </Link>
                  </div>
                </div>
                <Link href={project_url}>
                  <a className="image" data-aos="fade-left">
                    {card.image.url != "" && (
                      <ImageWrapper
                        alt=""
                        src={card.image.url}
                        blur={card.image.urlp}
                        layout="responsive"
                        width={1920}
                        height={1080}
                        // priority={true}
                        objectFit={"cover"}
                      />
                    )}
                    <div className="box-overlay">
                      <div>
                        <span>VEDI DETTAGLIO</span>
                        <svg viewBox="0 0 24 24">
                          <path d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CmsCollection;
